import { Children, isValidElement } from 'react';
import DataSet from '../data-set/DataSet';
import { DataSetSelection, FieldType } from '../data-set/enum';
import isFragment from '../_util/isFragment';
export const OTHER_OPTION_PROPS = '__OTHER_OPTION_PROPS__';
function getOptionsFromChildren(elements, data, fields, textField, valueField, disabledField, groups = []) {
    if (elements) {
        const getOption = (child) => {
            if (isFragment(child)) {
                const { children } = child.props;
                if (children) {
                    Children.forEach(children, getOption);
                }
            }
            else if (isValidElement(child)) {
                const { type } = child;
                if (type.__PRO_OPT_GROUP) {
                    const props = child.props;
                    getOptionsFromChildren(props.children, data, fields, textField, valueField, disabledField, groups.concat(props.label || ''));
                }
                else if (type.__PRO_OPTION) {
                    const { value, children, disabled, ...rest } = child.props;
                    data.push(groups.reduce((obj, group, index) => {
                        const name = `group-${index}`;
                        obj[name] = group;
                        if (!fields.find(field => field.name === name)) {
                            fields.push({
                                name,
                                type: FieldType.reactNode,
                                group: groups.length - 1,
                            });
                        }
                        return obj;
                    }, {
                        [OTHER_OPTION_PROPS]: rest,
                        [textField]: children,
                        [valueField]: value === undefined && isValidElement(children) ? children : value,
                        [disabledField]: disabled,
                    }));
                }
            }
        };
        Children.forEach(elements, getOption);
    }
}
export default function normalizeOptions({ textField, valueField, disabledField, multiple, children, getConfig, }) {
    const data = [];
    const fields = [
        {
            name: textField,
            type: FieldType.reactNode,
        },
        {
            name: valueField,
        },
        {
            name: disabledField,
            type: FieldType.boolean,
        },
    ];
    if (children) {
        getOptionsFromChildren(children, data, fields, textField, valueField, disabledField);
    }
    return new DataSet({
        data,
        fields,
        paging: false,
        selection: multiple ? DataSetSelection.multiple : DataSetSelection.single,
        autoLocateFirst: false,
    }, { getConfig });
}
